<template>
  <v-row align="center" justify="center">
    <v-col cols="12" sm="6">
      <v-card class="elevation-12 mt-10 mt-lg-16 mt-md-16 mt-sm-16">
        <v-card-title class="justify-center " style="
            background-color: var(--v-primary-base);
                      margin-bottom: 30px;
                      padding-top: 20px !important;
                    ">

          <img v-if="logoSmall" :src="logoSmall" style="width: 100%" alt="" />
          <img v-if="!logoSmall" src='../../assets/img/logo_w.svg' style="width: 100%" alt="" />
        </v-card-title>

        <v-card-text class="justify-center px-9 px-md-13 px-sm-9 px-lg-16">
          <p v-text="$t('Navigation.welcomeText_1')" class="text-center mb-0" />
          <p v-if="passwordField" v-text="$t('Navigation.welcomeText_2')" class="text-center" />

          <v-form @keyup.native.enter="login">
            <v-row>
              <v-col cols="12">
                <v-text-field v-if="passwordField" filled :label="$t('Headers.workflow_password')"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" :type="showPassword ? 'text' : 'password'"
                  prepend-inner-icon="mdi-lock" v-model="workflow.password" name="workflow_password"
                  @click:append="showPassword = !showPassword"></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="signature && !checked" justify="center">
              <v-col cols="12" class="text-center">
                <!-- <v-checkbox
                        class="d-inline-flex"
                        id="checkboxGTC"
                        v-model="workflow.gtcChecked"
                        :label="$t('Navigation.gtc')"
                      /> -->

                <v-checkbox v-model="workflow.gtcChecked" id="checkboxGTC">
                  <template v-slot:label>
                    <v-container class="ma-0 pa-0 mw-100">
                      {{ $t("RegisterPage.gdpr_2") }}
                      <a target="_blank" href="https://sign8.eu/impressum-datenschutzerklaerung/" @click.stop>
                        {{ $t("RegisterPage.gdpr") }}
                      </a>
                      {{ $t("RegisterPage.gdpr_4") }}

                      <a target="_blank" href="https://sign8.eu/agb/" @click.stop>
                        {{ $t("RegisterPage.gdpr_5") }}
                      </a>
                      {{ $t("RegisterPage.gdpr_3") }}
                    </v-container>
                  </template>
                </v-checkbox>
              </v-col>
            </v-row>
            <v-row v-if="signature && checked" justify="center" class="text-center">
              <v-container class="ma-0 pa-0 mw-100">
                {{ $t("i_accept") }}
                <a target="_blank" href="https://sign8.eu/impressum-datenschutzerklaerung/" @click.stop>
                  {{ $t("gpdr") }}
                </a>
                {{ $t("and") }}

                <a target="_blank" href="https://sign8.eu/agb/" @click.stop>
                  {{ $t("RegisterPage.gdpr_5") }}
                </a>
              </v-container>
            </v-row>
            <v-row v-if="!signature" justify="center">
              <v-container class="text-center ma-0 pa-0 mw-100">
                {{ $t("i_accept") }}
                <a target="_blank" href="https://sign8.eu/impressum-datenschutzerklaerung/" @click.stop>
                  {{ $t("gpdr") }}
                </a>
                {{ $t("and") }}

                <a target="_blank" href="https://sign8.eu/agb/" @click.stop>
                  {{ $t("RegisterPage.gdpr_5") }}
                </a>
              </v-container>
            </v-row>
          </v-form>

          <v-card-actions class="justify-center">
            <v-row justify="center">
              <v-col cols="12" class="text-center mb-5">
                <custom-button v-bind:block="false" :loading="loadingState" @click="login" :text="$t('Navigation.login')"
                  :disabled="signature && !workflow.gtcChecked" :color="mainColor" type="submit" />
              </v-col>
            </v-row>
          </v-card-actions>
          <v-row>
            <v-col cols="12" class="text-center">
              <p justify="center" class="type" :color="mainColor">
                <strong>{{ setSignerType() }}</strong>
              </p>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="text-center">
              <p justify="center">
                {{ $t('provided_by_sign8') }}
                <img src="../../assets/img/logo_g.svg" style="width: 30%" alt="" />
              </p>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import CustomButton from "../../components/ui/input/CustomButton";
import i18n from "../../i18n";
import { log } from "@/helpers/logger";

export default {
  name: "WorkflowLogin",
  title: i18n.t("WorkflowLogin.Title"),
  components: {
    CustomButton,
  },
  props: ["workflow_id", "signer_id"],
  computed: {
    loadingState() {
      return this.$store.state.loading;
    },
  },
  data() {
    return {
      customLogo: false,
      signature: false,
      mainColor: "",
      logoSmall: "",
      workflow: {
        password: "",
        mainColor: "",
        gtcChecked: false,
      },
      showPassword: false,
      passwordField: false,
      type: '',
      checked: false
    };
  },
  async created() {
    this.checkPath();

    await this.$store
      .dispatch("auth/checkWorkflowStatus", {
        workflow_id: this.workflow_id,
        signer_id: this.signer_id,
      })
      .then((res) => {
        log(
          "WorkflowLogin.index.created() - check workflow " + this.workflow_id,
          "info"
        );
        this.passwordField = res.password;
        this.signature = res.type.split('_')[1] === "signature" ? true : false;
        this.workflow.gtcChecked = res.workflow_checked;
        this.checked = res.workflow_checked;
        this.type = res.type;
      })
      .catch((err) => {
        log("WorkflowLogin.index.created() - " + err, "error");
      });

    await this.$store
      .dispatch("data/getInterfaceByWorkflow", this.workflow_id)
      .then((res) => {
        log(
          "WorkflowLogin.index.created() - get Interface for workflow " +
          this.workflow_id,
          "info"
        );

        this.logoSmall = res.mail_logo;
        let interface_data = (res.style != null ? res.style : "#1E6569");

        this.mainColor = interface_data;
        this.workflow.mainColor = interface_data;
        this.$vuetify.theme.themes.light.primary = interface_data;
        this.$vuetify.theme.themes.light.secondary = interface_data;
        this.$vuetify.theme.themes.light.accent = interface_data;
      })
      .catch((err) => {
        log("WorkflowLogin.index.created() - " + err, "error");
      })
  },

  methods: {
    setSignerType() {
      var text;
      switch (this.type) {
        case "s_signature":
          text = i18n.t("s_signature");
          break;
        case "a_seal":
          text = i18n.t("a_seal");
          break;
        case "a_signature":
          text = i18n.t("a_signature");
          break;
        case "q_seal":
          text = i18n.t("q_seal");
          break;
        case "q_signature":
          text = i18n.t("q_signature");
          break;
        default:
          text = '';
      };
      return text;
    },
    async login() {
      let data = {
        workflow_id: this.workflow_id,
        signer_id: this.signer_id,
        workflow: this.workflow,
      };
      this.$store
        .dispatch("auth/workflowLogin", data)
        .then(async (res) => {
          log(
            "WorkflowLogin.index.login() - login to workflow " +
            this.workflow_id,
            "info"
          );
          if (res.status === "FINISHED") {
            this.$store.commit("data/set_signed", true);
            await this.$router.push("/summary/finished");
          } else {
            await this.$router.push(
              "/workflow/" +
              this.workflow_id +
              "/" +
              this.signer_id +
              "/credentials"
            );
          }
        })
        .catch((err) => {
          log("WorkflowLogin.index.login() - " + err, "error");
        });
    },
    async checkPath() {
      let data = {
        workflow_id: this.workflow_id,
        signer_id: this.signer_id,
      };
      let correctPath = await this.$store.dispatch("auth/checkPath", data);
      if (!correctPath) {
        await this.$router.push("/");
      }
    },
  },
};
</script>

<style>
:root {
  --white: #fff;
  --black: #000000;
  --turquoise: #1e6668;
}

.Cookie--bottom {
  background-color: var(--white);
}

.Cookie--bottom .cookieButton {
  background-color: var(--turquoise);
  box-shadow: none;
  outline: none;
  border: none;
  color: var(--white);
  padding: 0.75rem 1.25rem;
}
</style>
